if (!customElements.get('video-thumbnail')) {
  class VideoThumbnail extends HTMLElement {
    constructor() {
      super();

      this.video = this.querySelector('video');

      this.handleMouseOver = this.handleMouseOver.bind(this);
      this.handleMouseOut = this.handleMouseOut.bind(this);
      this.handleKeyPress = this.handleKeyPress.bind(this);
    }

    connectedCallback() {
      // Play the video to prime it, then immediately pause
      this.video.play().then(() => {
        this.video.pause();
      });

      this.addEventListener('mouseover', this.handleMouseOver);
      this.addEventListener('mouseout', this.handleMouseOut);
      this.addEventListener('keypress', this.handleKeyPress);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseover', this.handleMouseOver);
      this.removeEventListener('mouseout', this.handleMouseOut);
      this.removeEventListener('keypress', this.handleKeyPress);
    }

    handleMouseOver() {
      this.video.play();
    }

    handleMouseOut() {
      this.video.pause();
    }

    handleKeyPress(event) {
      if (event.key === 'Enter') {
        this.click();
      }
    }
  }

  customElements.define('video-thumbnail', VideoThumbnail);
}
